// WizardStep2.jsx
import React from 'react';
import { useEffect } from 'react';
import MembershipForm from './MembershipForm';
import MembershipSummaryBanner from './MembershipSummaryBanner';

const WizardStep2 = ({ formData, itemsList, onFormChange, isEdit, onClose, onSubmit, onItemsChange, enableNext }) => {


  useEffect(() => {
    const isValid = (itemsList.length > 0);
    enableNext(isValid);
  }, [itemsList]);


  return (
    <>
      <h4 className="mb-4">Products And Services</h4>

      <MembershipSummaryBanner formData={formData} />
      <MembershipForm
        onFormChange={onFormChange}
        itemsList={itemsList}
        initialData={formData}
        isWizard={true}
        isEdit={isEdit}
        isLoader={false}
        submitHandler={onSubmit}
        onClose={onClose}
        disabled={false}
        additionalButton={null}
        membershipId={formData.id}
        onItemsChange={onItemsChange} // pass callback
        lockedFields={[
            'name',
            'unitPrice',
            'membershipPeriodQty',
            'membershipPeriodUnit',
            'membershipType',
            'membershipItemsNeverExpire',
            'membershipOfferBeginsOn',
            'membershipOfferEndsOn'
        ]}
      />
    </>
    );
};

export default WizardStep2;
